<template>
  <div class="longform-container">
    <TvaHeader />
    <TvaSideNav :index="index" />
    <ScrollIndicator />
    <div class="main-title">{{ $ml.get("title") }}</div>
    <TvaScroller
      class="scroller-pin"
      :threshold="0.2"
      :top="0"
      :bottom="1"
      :fixedTop="'20vh'"
      v-on:index="index = $event.value"
      v-on:progress="progress = $event.value"
      v-on:offset="offset = $event.value"
      v-on:activeSections="activeSections = $event.value"
      v-on:direction="direction = $event.value"
    >
      <div ref="background">
        <div
          v-for="(section, sectionIndex) in sections"
          :key="sectionIndex"
          class="scroller-section"
          :id="`scroller-section-0`"
        ></div>
      </div>
      <div ref="foreground">
        <div
          class="template-section"
          :id="section.section"
          v-for="(section, sectionIndex) in sections"
          :key="sectionIndex"
        >
          <div class="title">{{ section.title }}</div>
          <div class="small-title">component name</div>
          <div class="paragraph" v-html="section.componentName"></div>
          <div class="small-title" v-if="section.cssName">classi css globale</div>
          <div class="paragraph" v-html="section.cssName"></div>
          <div
            class="component-container"
            v-for="(component, componentIndex) in section.components"
            :key="componentIndex"
          >
            <component
              class="tva-component"
              v-bind:is="component.component"
              :config="component.config"
              :content="component.content"
              @click="component.content = $event"
            ></component>

            <div class="small-title" v-if="component.content">CONTENT</div>
            <json-viewer v-if="component.content" :value="component.content" :expand-depth="5"></json-viewer>
            <div class="small-title" v-if="component.config">CONFIG</div>
            <json-viewer v-if="component.config" :value="component.config" :expand-depth="5"></json-viewer>
          </div>
        </div>
      </div>
    </TvaScroller>
    <!-- <button @click="increment">Increment</button>
    <span>{{ count }}</span>-->
  </div>
</template>

<script>
import ScrollIndicator from "@/components/ScrollIndicator.vue";
import TvaScroller from "@/utilities/TvaScroller.vue";
import TvaSliderContainer from "@/utilities/TvaSliderContainer.vue";
import TvaParallax from "@/utilities/TvaParallax.vue";
import TvaBodymovin from "@/utilities/TvaBodymovin.vue";
import TvaVideoPlayer from "@/utilities/TvaVideoPlayer.vue";
import TvaSimpleButton from "@/utilities/TvaSimpleButton.vue";
import TvaAccordion from "@/utilities/TvaAccordion.vue";
import TvaDropdown from "@/utilities/TvaDropdown.vue";
import TvaBreadcrumb from "@/utilities/TvaBreadcrumb.vue";
import TvaContentSwitcher from "@/utilities/TvaContentSwitcher.vue";
import TvaCheckbox from "@/utilities/TvaCheckbox.vue";
import TvaHeader from "@/utilities/TvaHeader.vue";
import TvaSideNav from "@/utilities/TvaSideNav.vue";
import TvaVideoLazy from "@/utilities/TvaVideoLazy.vue";
import TvaImageLazy from "@/utilities/TvaImageLazy.vue";
import TvaSvgIcons from "@/utilities/TvaSvgIcons.vue";
import TvaCard from "@/utilities/TvaCard.vue";

import _ from "lodash";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "LongForm",
  data() {
    return {
      sections: null,
      index: 0,
      progress: 0,
      offset: 0,
      activeSections: [],
      direction: "",
      baseUrl: process.env.BASE_URL,
      typeOptions: {
        height: "40vh",
        background: "red"
      }
    };
  },
  created() {
    this.sections = _.cloneDeep(this.$ml.get("sections"));
  },
  computed: {
    ...mapGetters(["count"])
  },
  methods: {
    ...mapActions(["increment"])
  },
  components: {
    ScrollIndicator,
    TvaScroller,
    TvaParallax,
    TvaBodymovin,
    TvaVideoPlayer,
    TvaDropdown,
    TvaSimpleButton,
    TvaAccordion,
    TvaBreadcrumb,
    TvaContentSwitcher,
    TvaCheckbox,
    TvaHeader,
    TvaSideNav,
    TvaVideoLazy,
    TvaImageLazy,
    TvaSliderContainer,
    TvaSvgIcons,
    TvaCard
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/fonts.scss";

.fade-enter-active,
.fade-leave-active {
  transition: all 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-to,
.fade-leave {
  opacity: 1;
}
.longform-container {
  width: calc(100% - 20vw);
  margin-right: 0;
  margin-left: 20vw;
  padding: 7em 5em;
  .main-title {
    @include H2-black-left;
  }
  .template-section {
    margin: 4em 0 5em 0;
    border-top: solid 2px $secondary;
    &:first-of-type {
      border-top: none;
    }
    .title {
      width: 100%;
      margin: 1.5em 0 0.5em 0;
      @include template-title;
    }
    .paragraph {
      width: 100%;
      margin-bottom: 2em;
      @include body_2-black-left;
    }
    .small-title {
      margin: 1.5em 0 1em 0;
      @include overline-black-left;
    }
    .component-container {
      padding-bottom: 4em;
      border-bottom: solid 1px $ui-gray-3;
      &:last-of-type {
        border-bottom: none;
        padding-bottom: 1em;
      }
      .tva-component {
        margin: 4em 0 2em 0;
      }
    }
  }

  .scroller-pin {
    width: 100%;
    .background-pin {
      width: 100%;
      height: 60vh;
      .background-section {
        height: 100%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        img {
          width: 100%;
          // height: 100%;
          z-index: 1;
        }
        &.image {
          z-index: 1;
        }
        &.overlay {
          background: rgba(59, 44, 47, 0.8);
          z-index: 2;
          width: 100%;
        }
        &.text {
          z-index: 3;
          color: white;
          text-align: center;
          width: 100%;
          padding: 0 20em;
        }
      }
    }
  }
}
</style>
